/**
 * Live Score Bar - Navigation Buttons
 * Handles horizontal scrolling with left/right buttons
 */

document.addEventListener('DOMContentLoaded', function() {
    const liveScoreContent = document.querySelector('.live-score-content');
    const liveScoreEvents = document.querySelector('.live-score-events');
    const navLeft = document.querySelector('.live-score-nav-left');
    const navRight = document.querySelector('.live-score-nav-right');

    if (!liveScoreContent || !liveScoreEvents || !navLeft || !navRight) {
        return;
    }

    // Scroll amount (in pixels)
    const scrollAmount = 300;

    // Update button states based on scroll position
    function updateButtonStates() {
        const scrollLeft = liveScoreContent.scrollLeft;
        const maxScroll = liveScoreContent.scrollWidth - liveScoreContent.clientWidth;

        // Disable left button at start
        navLeft.disabled = scrollLeft <= 0;

        // Disable right button at end
        navRight.disabled = scrollLeft >= maxScroll - 1; // -1 for rounding errors
    }

    // Smooth scroll left
    navLeft.addEventListener('click', function() {
        liveScoreContent.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
        });
    });

    // Smooth scroll right
    navRight.addEventListener('click', function() {
        liveScoreContent.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
        });
    });

    // Update button states on scroll
    liveScoreContent.addEventListener('scroll', updateButtonStates);

    // Update button states on window resize
    window.addEventListener('resize', updateButtonStates);

    // Initial state
    updateButtonStates();

    // Update when new matches are loaded (if live updates are enabled)
    const observer = new MutationObserver(updateButtonStates);
    observer.observe(liveScoreEvents, {
        childList: true,
        subtree: true
    });
});
